<template>
  <div class="container college">
    <div class="header">
      <div><el-breadcrumb class="breadcrumb"
                       separator="/">
          <el-breadcrumb-item>赠送码</el-breadcrumb-item>
        </el-breadcrumb></div>
      <el-button type="primary"
                 @click="handleNoticeCreate">新建</el-button>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="开课码关键字"
                      prop="start_product_code_keyword">
          <el-input v-model="query.start_product_code_keyword"
                    placeholder="输入关键字"
                    clearable
                    @input="productCodeList()"></el-input>
        </el-form-item>
        <!-- <el-form-item label="状态"
                      prop="status">
          <el-select v-model="query.statuses"
                     placeholder="请选择"
                     clearable
                     @change="productCodeList(true)">
            <el-option label="正常"
                       value="1"> </el-option>
            <el-option label="已过期"
                       value="2"> </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="兑换状态"
                      prop="exchange_statuses">
          <el-select v-model="query.exchange_statuses"
                     placeholder="请选择"
                     clearable
                     @change="productCodeList(true)">
            <el-option label="未兑换"
                       value="0"> </el-option>
            <el-option label="兑换中"
                       value="1"> </el-option>
            <el-option label="已兑换"
                       value="2"> </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="results card">
      <div class="values-header"
           style="display:flex;justify-content: space-between;">
        <p class="title">赠送码列表</p>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.code_statuses"
                            @change="productCodeList">
              <el-radio-button v-for="(item, index) in statueds"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  @selection-change="handleSelectionChange"
                  border
                  style="width: 100%">
          <el-table-column type="selection"
                           width="50"
                           align="center"
                           fixed="left">
          </el-table-column>
          <el-table-column prop="task_title"
                           label="赠送码标题"
                           min-width="150"
                           align="center">
          </el-table-column>
          <el-table-column prop="code_product_name"
                           label="关联内容"
                           min-width="200"
                           align="center">
          </el-table-column>
          <el-table-column prop="code_status"
                           label="状态"
                           width="110"
                           align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.code_status==1"
                      type="success">正常</el-tag>
              <el-tag v-if="scope.row.code_status==2"
                      type="warning">已过期</el-tag>
              <el-tag v-if="scope.row.code_status==3"
                      type="info">已作废</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="code_count_total"
                           label="已使用/总数量"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.code_count_exchange_finish}}/{{scope.row.code_count_total}}
            </template>
          </el-table-column>
          <el-table-column prop="task_description"
                           label="赠送说明"
                           min-width="150"
                           align="center">
          </el-table-column>
          <el-table-column prop="ref_creator_admin_nickname"
                           label="创建人"
                           min-width="70"
                           align="center">
          </el-table-column>
          <el-table-column label="创建时间"
                           min-width="90"
                           align="center">
            <template slot-scope="scope">
              <span>{{$moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效时间"
                           min-width="130"
                           align="center">
            <template slot-scope="scope">
              <span>{{$moment(scope.row.code_start_time).format('YYYY-MM-DD HH:mm')}}至{{$moment(scope.row.code_end_time).format('YYYY-MM-DD HH:mm')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="180"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <el-link :underline="false"
                       type="primary"
                       style="marginRight:5px"
                       @click="download(scope.row)">下载</el-link> | <el-link :underline="false"
                       type="primary"
                       style="marginLeft:5px"
                       @click="handleContion(scope.row)">查看使用情况</el-link>

            </template>
          </el-table-column>

        </el-table>

      </div>
      <div class="footer">
        <div>
          <el-button size="mini"
                     type="danger"
                     @click="handleToDeleteAll()">批量删除</el-button>
        </div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <addProductCode :visible="createDialog"
                    @close="handleClose"
                    @sumbit="productCodeList()"></addProductCode>

    <serviceCondition :visible="conditonDialog"
                      :editRow="editRow"
                      @close="handleLookClose"
                      @sumbit="productCodeList()"></serviceCondition>
  </div>
</template>

<script>
import {
  startProductCodelist,
  taskExport,
  startProductCodeDelete,
  taskList,
} from '@/api/productExchange'
import addProductCode from '@/components/dialog/productCode/addProductCode'
import serviceCondition from '@/components/dialog/productCode/serviceCondition'
export default {
  components: { addProductCode, serviceCondition },
  data() {
    return {
      createDialog: false,

      conditonDialog: false,
      editRow: {},
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        code_statuses: 1,
      },
      pageTotal: 10,
      results: [],
      types: [
        { label: '全部', value: '' },
        { label: '系统消息', value: 1 },
        { label: '课程通知', value: 2 },
      ],
      statueds: [
        { label: '全部', value: '' },
        { label: '正常', value: '1' },
        { label: '已过期', value: '2' },
      ],
      chooseList: [],
    }
  },
  created() {
    this.productCodeList()
  },
  methods: {
    download(row) {
      taskExport({ start_code_task_id: row.id }).then((res) => {
        if (res) {
          this.$message.success(`导出成功`)
          window.open(res.url)
        }
      })
    },
    handleContion(row) {
      this.editRow = row
      this.conditonDialog = true
    },
    // 消息列表请求
    productCodeList() {
      taskList(this.query).then((res) => {
        this.results = res.list || []

        this.pageTotal = res.count
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.productCodeList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.productCodeList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.productCodeList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.productCodeList()
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleClose() {
      this.createDialog = false
    },
    handleLookClose() {
      this.conditonDialog = false
    },
    // 消息创建
    handleNoticeCreate() {
      this.createDialog = true
    },

    // 消息删除
    handleToDeleteAll(row) {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          let id = this.chooseList.map((v) => {
            return v.id
          })
          startProductCodeDelete({ ids: id }).then((res) => {
            this.$message.success(`删除成功`)
            this.productCodeList()
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang="less">
.header {
  background: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.buttonRecord {
  cursor: pointer;
  width: 100px;
  border-radius: 2px;
  height: 32px;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  background: #409eff;
}
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;

      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
</style>
